export function getCookie(name) {
  const cookieName = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(cookieName)) {
      return decodeURIComponent(cookie.substring(cookieName.length));
    }
  }

  return null;
}

export function setCookie(name, value, days = 30) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
    value
  )}; ${expires}; path=/; SameSite=Lax`;
}

export function deleteCookie(name) {
  document.cookie = `${encodeURIComponent(
    name
  )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}

export function getPersistentItem(key) {
  const cookieValue = getCookie(key);

  if (cookieValue !== null && cookieValue !== "") {
    if (localStorage.getItem(key) !== cookieValue) {
      localStorage.setItem(key, cookieValue);
    }
    return cookieValue;
  }

  const storageValue = localStorage.getItem(key);
  if (storageValue !== null && storageValue !== "") {
    setCookie(key, storageValue, 30);
    return storageValue;
  }

  return null;
}

export function setPersistentItem(key, value, days = 30) {
  localStorage.setItem(key, value);
  setCookie(key, value, days);
}

export function removePersistentItem(key) {
  localStorage.removeItem(key);
  deleteCookie(key);
}

export function syncPersistentKeys(keys) {
  keys.forEach((key) => {
    getPersistentItem(key);
  });
}
